import React from 'react';
import { useCopyToClipboard } from 'react-use';
import {
  Dropdown,
  DropdownButton,
  DropdownContent,
  DropdownItem,
  EnvelopeIcon,
  IconButton,
  useSnackbar,
} from 'ui-components';
import { ManagerShortType } from '~/types';

interface ManagerDropdownProps {
  manager: ManagerShortType;
  title?: string;
  isShared: boolean;
}

export function ManagerDropdown({
  manager,
  title = 'Talent Manager',
  isShared,
}: ManagerDropdownProps) {
  const snackbar = useSnackbar();
  const [_state, copyToClipboard] = useCopyToClipboard();

  const handleManagerClick = (e: React.MouseEvent, email: string) => {
    e.stopPropagation();

    copyToClipboard(email);

    snackbar.success({
      description: 'Email Copied!',
      duration: 2000,
      isCloseable: true,
    });
  };

  if (!manager) return null;

  return (
    <Dropdown placement="right">
      {({ buttonRef, getReferenceProps }) => (
        <>
          {!isShared ? (
            <DropdownButton>
              <EnvelopeIcon boxSize={4} />
              {title}
            </DropdownButton>
          ) : (
            <IconButton
              aria-label="Open menu"
              icon={<EnvelopeIcon boxSize={4} />}
              ref={buttonRef}
              size="md"
              variant="transparent"
              {...getReferenceProps()}
            />
          )}
          <DropdownContent>
            <DropdownItem
              onClick={(e) => handleManagerClick(e, manager.email)}
              trackId="wm-talent-copy-manager-email"
            >
              {/* Default to email for managers that haven't registered yet */}
              <EnvelopeIcon boxSize={4} /> {manager.name || manager.email}
            </DropdownItem>
          </DropdownContent>
        </>
      )}
    </Dropdown>
  );
}
